// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateWarranties = (state, action) => action.warranties;

const resetWarranties = () => getDefaultState().warranties;

export default (state = getDefaultState().warranties, action) => {

    const actionTypes = {
        [actions.UPDATE_PART_COVERAGE_SEARCH_WARRANTIES_SUCCESS]: updateWarranties,
        [actions.RESET_PART_COVERAGE_SEARCH_REPORT]: resetWarranties,
        [actions.RESET_PART_COVERAGE_SEARCH_ADDITIONAL_INFORMATION]: resetWarranties
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/warranties.js